// extracted by mini-css-extract-plugin
export var modalFooter = "_sq-0";